export const SHOW_LOADING_SCREEN = "redux/SHOW_LOADING_SCREEN"
export const SHOW_COVID19_ALERT_BANNER = "redux/SHOW_COVID19_ALERT_BANNER"
export const SET_LOCALE = "redux/SET_LOCALE"
export const RESTORE = "redux/RESTORE"



// WEBPACK FOOTER //
// ./assets/redux/actionTypes.js